import React, { Component } from 'react';
import { View, Image, ScrollView, StyleSheet, TouchableOpacity, TouchableWithoutFeedback, FlatList, ActivityIndicator, RefreshControl } from 'react-native';
// import OfflineHandler from './../OfflineHandler'; 
import Header from './../../components/Header';



class FullScreenWebView extends React.Component{
    state = {
        description: null
    }
    componentDidMount(){
      
      const { location = {} } = this.props;
      const { state = {} } = location;
      const { description } = state
     
      this.setState({
          description: description || 'Not Found',        
      });

    //   this.props.navigation.setParams({ 
    //     title: title,
    //   })
    }
    render(){
        const {description} = this.state
        return(
            <> 
                <Header
                title="Test Description"
                headerLeftClick={() => this.props.history.goBack()}
                backButton={true}
            />            
             <div className='full-height'> 
                <ScrollView style={styles.mainContainer}>
                <View style={{marginHorizontal: 10, marginVertical: 10}}>
                        <div dangerouslySetInnerHTML={{__html: description ? description : 'No Description'}}>
                        </div>
                    </View>            
                </ScrollView>
            </div>  
            </>
        )
    }
}

const styles = StyleSheet.create({
    mainContainer: {
        flex: 1,
        backgroundColor: '#fff'

    }
})

export default FullScreenWebView;